"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.FontFormats={eot:"embedded-opentype",woff:"woff",woff2:"woff2",otf:"opentype",ttf:"truetype",svg:"svg"};const e=["serif","sans-serif","monospace","cursive","fantasy","system-ui","math","emoji","fangsong"];exports.fontToCss=(s=>{const o=[];return s.name&&o.push(s.name),o.push(...s.fallbacks),(s=>s.map(s=>e.includes(s)?s:`"${s}"`))(o).join()});
//# sourceMappingURL=/@diez/web-sdk-common/lib/css-font.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@diez/web-sdk-common/lib/css-font.js
// module id = 415
// module chunks = 168707334958949